export default "__VITE_ASSET__CWtY9YD$__"